<template>
  <div :class="['alert', props.type]">
    <slot name="icon" v-if="props.showIcon || props.type === 'warning'">
      <CircleWarningIcon class="icon" />
    </slot>
    <span class="info">
      <slot />
    </span>
  </div>
</template>

<script setup lang="ts">
import CircleWarningIcon from '../../assets/circle-warning.svg?component';

const props = withDefaults(
  defineProps<{
    type: 'warning';
    showIcon: boolean;
  }>(),
  {
    type: 'warning',
    showIcon: true,
  },
);
</script>

<style lang="scss" scoped>
.alert {
  display: flex;
  align-items: flex-start;
  padding: 8px 16px;
  font-size: 12px;
  line-height: 24px;
  border-radius: var(--x-radius-medium);
  font-weight: 400;
  .info {
    flex: 1 1 0%;
    color: var(--x-text-1);
  }
  .icon {
    margin-top: 3px;
    margin-right: 8px;
    height: 16px;
    width: 16px;
    transform: translateY(1px);
  }
  &.warning {
    .icon {
      color: var(--x-warning-6);
    }
    color: var(--x-warning-7);
    background: var(--x-warning-1);
    border: 1px solid var(--x-warning-3);
  }
  &.info {
    color: var(--x-purple-7);
    background: var(--x-purple-1);
    border: 1px solid var(--x-purple-3);
    .icon {
      color: var(--x-purple-6);
    }
  }
}
</style>
